import { Flex, Typography, Image } from "antd";
import { comma, BACKEND_URL_MAIN } from "../../../utils/util";

export const column = [
  {
    title: (
      <>
        ลำดับ
        <br />
        No.
      </>
    ),
    key: "index",
    align: "center",
    width: "10%",
    // onCell: () => ({
    //   style: {
    //     borderLeft: "1px solid var(---color--1)",
    //   },
    // }),
    // render: (_, record, idx) => <span key={record?.stcode}>{idx + 1}</span>,
    render: (_, record, idx) => (
      <Typography.Text className="tx-info">{idx + 1}</Typography.Text>
    ),
  },
  {
    title: (
      <>
        รายการสินค้า
        <br />
        Description
      </>
    ),
    align: "center",
    key: "stname",
    dataIndex: "stname",
    render: (_, record, rec) => {
      const img = (!!record.file_name ? `/uploads/` + record.file_name : `/Logo-AI.png`
      );
      return <>
        <Flex justify="space-between" >
          <Typography.Text className="tx-info">
            {rec + 1}. {record?.stname} 
          </Typography.Text>
          {(record?.show_pic==='แสดง')&&<Image
            style={{ borderRadius: 10 }}
            preview={false}
            height={50}
            alt={`Image ${record.file_name}`}
            src={`${BACKEND_URL_MAIN}` + img}
          />}
        </Flex>
      </>

    },
  },
  // {
  //   title: "รูปประกอบ",
  //   dataIndex: "file",
  //   key: "file",
  //   width: 120,
  //   align: "center",
  //   render: (im, rec) => {
  //     const img = (!!rec.file_name ? `/uploads/` + rec.file_name : `/Logo-AI.png`
  //     );
  //     return <>
  //       <Image
  //         style={{ borderRadius: 10 }}
  //         preview={false}
  //         height={75}
  //         alt={`Image ${rec.file_name}`}
  //         src={`${BACKEND_URL_MAIN}` + img}
  //       />
  //     </>
  //   },
  // },
  {
    title: (
      <>
        จำนวน
        <br />
        Qty
      </>
    ),
    align: "center",
    key: "qty",
    dataIndex: "qty",
    width: 100,
    render: (v) => (
      <Typography.Text className="tx-info">{comma(Number(v))}</Typography.Text>
    ),
  },
  // {
  //   title: (
  //     <>
  //       หน่วย
  //       <br />
  //       Unit Price
  //     </>
  //   ),
  //   align: "right",
  //   width: 100,
  //   key: "unit",
  //   dataIndex: "unit",
  // },
  {
    title: (
      <>
        ราคา/หน่วย
        <br />
        Unit Price
      </>
    ),
    align: "center",
    width: 100,
    key: "price",
    dataIndex: "price",
    render: (v) => (
      <Typography.Text className="tx-info">{comma(Number(v))}</Typography.Text>
    ),
  },
  {
    title: (
      <>
        จำนวนเงิน
        <br />
        Amount
      </>
    ),
    align: "right",
    width: 100,
    key: "amount",
    dataIndex: "amount",
    onCell: () => ({
      style: {
        borderRight: "1px solid var(---color--1)",
      },
    }),
    render: (_, record) => (
      <Typography.Text className="tx-info">
        {comma(Number(record.price * record.qty), 2, 2)}
      </Typography.Text>
    ),
  },
];
